import { Dialog, TextField } from "@mui/material";
import { useState } from "react";

import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueHistoricoFinanceiro, THistoricoFinanceiro } from "../../types/api/financeiro/historico-financeiro";

export default function SelectHistoricoFinanceiro({
    value,
    onChange,
    required = false,
    error = false,
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value?.id ? `${value.id} - ${value.nome}` : ""

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Histórico`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        title="Selecionar histórico"
                        queryPath="/financeiro/pesquisar-historico"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.id} - ${item.nome}`}
                        defaultValue={value || defValueHistoricoFinanceiro}
                        onChange={(value) => {
                            onChange(value as THistoricoFinanceiro)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: THistoricoFinanceiro
    onChange: (arg: THistoricoFinanceiro | null) => void
    required?: boolean
    error?: boolean
}